import type { LevelMeta } from '../logic/types'

interface Props {
  level: LevelMeta
  onResetAndStart: () => void
  onHome: () => void
}

export function Done({ level, onResetAndStart, onHome }: Props) {
  return (
    <section className="screen active" id="scr-done">
      <div className="center-wrap">
        <div style={{ fontSize: 64 }} aria-hidden>🏁</div>
        <h2 className="res-title">Niveau voltooid!</h2>
        <div className="res-sub">
          Все упражнения уровня {level.name} ({level.cefr}) отвечены верно.
          Они больше не будут появляться — пока вы не сбросите прогресс уровня.
        </div>
      </div>
      <div className="bottom-cta">
        <button className="btn danger" onClick={onResetAndStart}>
          Сбросить и пройти заново
        </button>
        <button className="btn ghost" onClick={onHome}>
          Naar het overzicht
        </button>
      </div>
    </section>
  )
}
